import { Link } from 'react-router';
import { CTA_ON_CLICK_FUNCTION_IDS } from '@iscr/contentful/components/CTA';

const showPrescUpd = () => {
	app.trigger(app.events.SHOW_POPUP, { pt: 'cx_txt', pn: 'prescriptions-update', txt: 'Online prescriptions update' })
};

export const prescUpdate = {[CTA_ON_CLICK_FUNCTION_IDS.OPEN_PRESC_UPD]: showPrescUpd}

export default function LearnMore({ text = ' Learn more.' }) {
	return (
		<Link className="text-blue-800" onClick={showPrescUpd}>
			{text}
		</Link>
	);
}
